import { formatShareQty } from "./investorRedeemEligibility";
import { lockInCalendarDaysRemaining } from "./lockInDisplay";

const bdt = new Intl.NumberFormat("en-BD", { style: "currency", currency: "BDT", minimumFractionDigits: 2 });

/** Compact transfer-fee % for investor UI (e.g. 0.1% not 0.100%). */
export function formatTransferFeePctLabel(pct) {
  const n = Number(pct);
  if (!Number.isFinite(n)) return "—";
  const s = n >= 1 ? n.toFixed(2) : n.toFixed(3);
  return `${parseFloat(s)}%`;
}

/** One-line lock-in note for transfer preview (transfers allowed; redeem later). */
export function formatTransferLockInNote(unlockIso) {
  if (unlockIso == null || unlockIso === "") return "";
  const end = new Date(unlockIso);
  if (Number.isNaN(end.getTime())) return "";
  const date = new Intl.DateTimeFormat(undefined, { dateStyle: "medium" }).format(end);
  const days = lockInCalendarDaysRemaining(unlockIso);
  if (days == null) return "";
  if (days === 0) return `Redeem shares from ${date}.`;
  if (days === 1) return `Lock-in: 1 day left — redeem from ${date}.`;
  return `Lock-in: ${days} days left — redeem from ${date}.`;
}

export function formatTransferPreviewFeeBdt(preview) {
  return bdt.format(Number(preview?.feeTotalBdt || preview?.estimatedTransferFeeBdt || 0));
}

export function formatTransferPreviewNavBdt(preview) {
  return bdt.format(Number(preview?.lockedNavPerShare || preview?.navPerShare || 0));
}

/** Shares available to transfer (held minus redemption lock). */
export function transferableSharesFromHolding(holding) {
  const held = Number(holding?.shares_held ?? holding?.sharesHeld ?? 0);
  const pending = Number(holding?.shares_pending_redemption ?? holding?.sharesPendingRedemption ?? 0);
  return Math.max(0, held - pending);
}

export function validateTransferSharesInput(shares, available) {
  const sh = Number(shares);
  if (!Number.isFinite(sh) || sh <= 0) {
    return { valid: false, message: "Enter a share amount greater than zero." };
  }
  const avail = Number(available || 0);
  if (sh > avail + 0.0001) {
    return {
      valid: false,
      message: `Insufficient shares to transfer. Available shares to transfer: ${formatShareQty(avail)}.`,
    };
  }
  return { valid: true, message: "" };
}
